/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AcknowledgeEventRecordResponseDto,
  BackfillEventRecordStatusDto,
  BackfillEventRecordStatusResponseDto,
  CreateEventRecordCommandControllerCreate201,
  CreateEventRecordDto,
  EventRecordDetailResponseDto,
  EventRecordStatusResponseDto,
  GetEventRecordForPrintQueryControllerGetParams,
  GetEventRecordPdfResponseDto,
  ListEventRecordsQueryControllerListParams,
  ListEventRecordsResponseDto,
  RequestEventRecordAcknowledgementDto,
  RequestEventRecordAcknowledgementResponseDto,
} from "../model";

import { axiosClient } from "../../lib/api";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * Creates an immutable event record against an active event type. Required fields per the event type schema are validated server-side. Restricted to leaders, deputy managers, and managers.
 * @summary Submit a new event record (leaders and above only)
 */
export const createEventRecordCommandControllerCreate = (
  nurseryId: string,
  createEventRecordDto: CreateEventRecordDto,
  signal?: AbortSignal,
) => {
  return axiosClient<CreateEventRecordCommandControllerCreate201>({
    url: `/v1/nurseries/${nurseryId}/event-records`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createEventRecordDto,
    signal,
  });
};

export const getCreateEventRecordCommandControllerCreateMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEventRecordCommandControllerCreate>>,
    TError,
    { nurseryId: string; data: CreateEventRecordDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createEventRecordCommandControllerCreate>>,
  TError,
  { nurseryId: string; data: CreateEventRecordDto },
  TContext
> => {
  const mutationKey = ["createEventRecordCommandControllerCreate"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createEventRecordCommandControllerCreate>>,
    { nurseryId: string; data: CreateEventRecordDto }
  > = (props) => {
    const { nurseryId, data } = props ?? {};

    return createEventRecordCommandControllerCreate(nurseryId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateEventRecordCommandControllerCreateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createEventRecordCommandControllerCreate>>
  >;
export type CreateEventRecordCommandControllerCreateMutationBody =
  CreateEventRecordDto;
export type CreateEventRecordCommandControllerCreateMutationError = void;

/**
 * @summary Submit a new event record (leaders and above only)
 */
export const useCreateEventRecordCommandControllerCreate = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createEventRecordCommandControllerCreate>>,
      TError,
      { nurseryId: string; data: CreateEventRecordDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createEventRecordCommandControllerCreate>>,
  TError,
  { nurseryId: string; data: CreateEventRecordDto },
  TContext
> => {
  return useMutation(
    getCreateEventRecordCommandControllerCreateMutationOptions(options),
    queryClient,
  );
};
/**
 * One Events Hub tab of records, filterable by event type, category and submission date range, sorted and paginated server-side. The response carries counts for every tab so the badges stay in step with the rows. Visible to managers + deputy managers.
 * @summary List event records for a nursery (Events Hub)
 */
export const listEventRecordsQueryControllerList = (
  nurseryId: string,
  params?: ListEventRecordsQueryControllerListParams,
  signal?: AbortSignal,
) => {
  return axiosClient<ListEventRecordsResponseDto>({
    url: `/v1/nurseries/${nurseryId}/event-records`,
    method: "GET",
    params,
    signal,
  });
};

export const getListEventRecordsQueryControllerListQueryKey = (
  nurseryId: string,
  params?: ListEventRecordsQueryControllerListParams,
) => {
  return [
    `/v1/nurseries/${nurseryId}/event-records`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListEventRecordsQueryControllerListQueryOptions = <
  TData = Awaited<ReturnType<typeof listEventRecordsQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  params?: ListEventRecordsQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listEventRecordsQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListEventRecordsQueryControllerListQueryKey(nurseryId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listEventRecordsQueryControllerList>>
  > = ({ signal }) =>
    listEventRecordsQueryControllerList(nurseryId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: nurseryId !== null && nurseryId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listEventRecordsQueryControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListEventRecordsQueryControllerListQueryResult = NonNullable<
  Awaited<ReturnType<typeof listEventRecordsQueryControllerList>>
>;
export type ListEventRecordsQueryControllerListQueryError = void;

export function useListEventRecordsQueryControllerList<
  TData = Awaited<ReturnType<typeof listEventRecordsQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  params: undefined | ListEventRecordsQueryControllerListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listEventRecordsQueryControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEventRecordsQueryControllerList>>,
          TError,
          Awaited<ReturnType<typeof listEventRecordsQueryControllerList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListEventRecordsQueryControllerList<
  TData = Awaited<ReturnType<typeof listEventRecordsQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  params?: ListEventRecordsQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listEventRecordsQueryControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEventRecordsQueryControllerList>>,
          TError,
          Awaited<ReturnType<typeof listEventRecordsQueryControllerList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListEventRecordsQueryControllerList<
  TData = Awaited<ReturnType<typeof listEventRecordsQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  params?: ListEventRecordsQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listEventRecordsQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List event records for a nursery (Events Hub)
 */

export function useListEventRecordsQueryControllerList<
  TData = Awaited<ReturnType<typeof listEventRecordsQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  params?: ListEventRecordsQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listEventRecordsQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListEventRecordsQueryControllerListQueryOptions(
    nurseryId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Records a manager/deputy acknowledgement of a submitted event record. One acknowledgement per record — acknowledging an already-acknowledged record returns 409.
 * @summary Acknowledge an event record (managers + deputy managers)
 */
export const acknowledgeEventRecordCommandControllerAcknowledge = (
  eventRecordId: string,
  signal?: AbortSignal,
) => {
  return axiosClient<AcknowledgeEventRecordResponseDto>({
    url: `/v1/event-records/${eventRecordId}/acknowledge`,
    method: "POST",
    signal,
  });
};

export const getAcknowledgeEventRecordCommandControllerAcknowledgeMutationOptions =
  <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof acknowledgeEventRecordCommandControllerAcknowledge>
      >,
      TError,
      { eventRecordId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof acknowledgeEventRecordCommandControllerAcknowledge>
    >,
    TError,
    { eventRecordId: string },
    TContext
  > => {
    const mutationKey = ["acknowledgeEventRecordCommandControllerAcknowledge"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof acknowledgeEventRecordCommandControllerAcknowledge>
      >,
      { eventRecordId: string }
    > = (props) => {
      const { eventRecordId } = props ?? {};

      return acknowledgeEventRecordCommandControllerAcknowledge(eventRecordId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type AcknowledgeEventRecordCommandControllerAcknowledgeMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof acknowledgeEventRecordCommandControllerAcknowledge>
    >
  >;

export type AcknowledgeEventRecordCommandControllerAcknowledgeMutationError =
  void;

/**
 * @summary Acknowledge an event record (managers + deputy managers)
 */
export const useAcknowledgeEventRecordCommandControllerAcknowledge = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof acknowledgeEventRecordCommandControllerAcknowledge>
      >,
      TError,
      { eventRecordId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof acknowledgeEventRecordCommandControllerAcknowledge>
  >,
  TError,
  { eventRecordId: string },
  TContext
> => {
  return useMutation(
    getAcknowledgeEventRecordCommandControllerAcknowledgeMutationOptions(
      options,
    ),
    queryClient,
  );
};
/**
 * Closes the record: the underlying matter is dealt with. Allowed straight from awaiting acknowledgement — closing a record does not require acknowledging it first.
 * @summary Mark an event record resolved (managers and group admins)
 */
export const transitionEventRecordCommandControllerResolve = (
  eventRecordId: string,
  signal?: AbortSignal,
) => {
  return axiosClient<EventRecordStatusResponseDto>({
    url: `/v1/event-records/${eventRecordId}/resolve`,
    method: "POST",
    signal,
  });
};

export const getTransitionEventRecordCommandControllerResolveMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof transitionEventRecordCommandControllerResolve>>,
    TError,
    { eventRecordId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof transitionEventRecordCommandControllerResolve>>,
  TError,
  { eventRecordId: string },
  TContext
> => {
  const mutationKey = ["transitionEventRecordCommandControllerResolve"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof transitionEventRecordCommandControllerResolve>>,
    { eventRecordId: string }
  > = (props) => {
    const { eventRecordId } = props ?? {};

    return transitionEventRecordCommandControllerResolve(eventRecordId);
  };

  return { mutationFn, ...mutationOptions };
};

export type TransitionEventRecordCommandControllerResolveMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof transitionEventRecordCommandControllerResolve>>
  >;

export type TransitionEventRecordCommandControllerResolveMutationError = void;

/**
 * @summary Mark an event record resolved (managers and group admins)
 */
export const useTransitionEventRecordCommandControllerResolve = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof transitionEventRecordCommandControllerResolve>>,
      TError,
      { eventRecordId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof transitionEventRecordCommandControllerResolve>>,
  TError,
  { eventRecordId: string },
  TContext
> => {
  return useMutation(
    getTransitionEventRecordCommandControllerResolveMutationOptions(options),
    queryClient,
  );
};
/**
 * Files the record away. It stays in History and can be restored.
 * @summary Archive an event record (managers and group admins)
 */
export const transitionEventRecordCommandControllerArchive = (
  eventRecordId: string,
  signal?: AbortSignal,
) => {
  return axiosClient<EventRecordStatusResponseDto>({
    url: `/v1/event-records/${eventRecordId}/archive`,
    method: "POST",
    signal,
  });
};

export const getTransitionEventRecordCommandControllerArchiveMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof transitionEventRecordCommandControllerArchive>>,
    TError,
    { eventRecordId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof transitionEventRecordCommandControllerArchive>>,
  TError,
  { eventRecordId: string },
  TContext
> => {
  const mutationKey = ["transitionEventRecordCommandControllerArchive"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof transitionEventRecordCommandControllerArchive>>,
    { eventRecordId: string }
  > = (props) => {
    const { eventRecordId } = props ?? {};

    return transitionEventRecordCommandControllerArchive(eventRecordId);
  };

  return { mutationFn, ...mutationOptions };
};

export type TransitionEventRecordCommandControllerArchiveMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof transitionEventRecordCommandControllerArchive>>
  >;

export type TransitionEventRecordCommandControllerArchiveMutationError = void;

/**
 * @summary Archive an event record (managers and group admins)
 */
export const useTransitionEventRecordCommandControllerArchive = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof transitionEventRecordCommandControllerArchive>>,
      TError,
      { eventRecordId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof transitionEventRecordCommandControllerArchive>>,
  TError,
  { eventRecordId: string },
  TContext
> => {
  return useMutation(
    getTransitionEventRecordCommandControllerArchiveMutationOptions(options),
    queryClient,
  );
};
/**
 * Undoes an archive, returning the record to whatever state it held before.
 * @summary Restore an archived event record (managers and group admins)
 */
export const transitionEventRecordCommandControllerRestore = (
  eventRecordId: string,
  signal?: AbortSignal,
) => {
  return axiosClient<EventRecordStatusResponseDto>({
    url: `/v1/event-records/${eventRecordId}/restore`,
    method: "POST",
    signal,
  });
};

export const getTransitionEventRecordCommandControllerRestoreMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof transitionEventRecordCommandControllerRestore>>,
    TError,
    { eventRecordId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof transitionEventRecordCommandControllerRestore>>,
  TError,
  { eventRecordId: string },
  TContext
> => {
  const mutationKey = ["transitionEventRecordCommandControllerRestore"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof transitionEventRecordCommandControllerRestore>>,
    { eventRecordId: string }
  > = (props) => {
    const { eventRecordId } = props ?? {};

    return transitionEventRecordCommandControllerRestore(eventRecordId);
  };

  return { mutationFn, ...mutationOptions };
};

export type TransitionEventRecordCommandControllerRestoreMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof transitionEventRecordCommandControllerRestore>>
  >;

export type TransitionEventRecordCommandControllerRestoreMutationError = void;

/**
 * @summary Restore an archived event record (managers and group admins)
 */
export const useTransitionEventRecordCommandControllerRestore = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof transitionEventRecordCommandControllerRestore>>,
      TError,
      { eventRecordId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof transitionEventRecordCommandControllerRestore>>,
  TError,
  { eventRecordId: string },
  TContext
> => {
  return useMutation(
    getTransitionEventRecordCommandControllerRestoreMutationOptions(options),
    queryClient,
  );
};
/**
 * Returns a resolved record to in progress. An archived record must be restored first — restore and re-open are distinct actions with different permissions.
 * @summary Re-open a resolved event record (group admins only)
 */
export const transitionEventRecordCommandControllerReopen = (
  eventRecordId: string,
  signal?: AbortSignal,
) => {
  return axiosClient<EventRecordStatusResponseDto>({
    url: `/v1/event-records/${eventRecordId}/reopen`,
    method: "POST",
    signal,
  });
};

export const getTransitionEventRecordCommandControllerReopenMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof transitionEventRecordCommandControllerReopen>>,
    TError,
    { eventRecordId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof transitionEventRecordCommandControllerReopen>>,
  TError,
  { eventRecordId: string },
  TContext
> => {
  const mutationKey = ["transitionEventRecordCommandControllerReopen"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof transitionEventRecordCommandControllerReopen>>,
    { eventRecordId: string }
  > = (props) => {
    const { eventRecordId } = props ?? {};

    return transitionEventRecordCommandControllerReopen(eventRecordId);
  };

  return { mutationFn, ...mutationOptions };
};

export type TransitionEventRecordCommandControllerReopenMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof transitionEventRecordCommandControllerReopen>>
  >;

export type TransitionEventRecordCommandControllerReopenMutationError = void;

/**
 * @summary Re-open a resolved event record (group admins only)
 */
export const useTransitionEventRecordCommandControllerReopen = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof transitionEventRecordCommandControllerReopen>>,
      TError,
      { eventRecordId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof transitionEventRecordCommandControllerReopen>>,
  TError,
  { eventRecordId: string },
  TContext
> => {
  return useMutation(
    getTransitionEventRecordCommandControllerReopenMutationOptions(options),
    queryClient,
  );
};
/**
 * Destroys the record and its acknowledgement and status history. This is irreversible and removes Ofsted inspection evidence — a deletion log row retains who deleted what and when, but not the record's contents. Refused with 409 if follow-up actions are attached.
 * @summary Permanently delete an event record (group admins only)
 */
export const deleteEventRecordCommandControllerRemove = (
  eventRecordId: string,
  signal?: AbortSignal,
) => {
  return axiosClient<void>({
    url: `/v1/event-records/${eventRecordId}`,
    method: "DELETE",
    signal,
  });
};

export const getDeleteEventRecordCommandControllerRemoveMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteEventRecordCommandControllerRemove>>,
    TError,
    { eventRecordId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteEventRecordCommandControllerRemove>>,
  TError,
  { eventRecordId: string },
  TContext
> => {
  const mutationKey = ["deleteEventRecordCommandControllerRemove"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteEventRecordCommandControllerRemove>>,
    { eventRecordId: string }
  > = (props) => {
    const { eventRecordId } = props ?? {};

    return deleteEventRecordCommandControllerRemove(eventRecordId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteEventRecordCommandControllerRemoveMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof deleteEventRecordCommandControllerRemove>>
  >;

export type DeleteEventRecordCommandControllerRemoveMutationError = void;

/**
 * @summary Permanently delete an event record (group admins only)
 */
export const useDeleteEventRecordCommandControllerRemove = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteEventRecordCommandControllerRemove>>,
      TError,
      { eventRecordId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteEventRecordCommandControllerRemove>>,
  TError,
  { eventRecordId: string },
  TContext
> => {
  return useMutation(
    getDeleteEventRecordCommandControllerRemoveMutationOptions(options),
    queryClient,
  );
};
/**
 * @summary Get an event record with its acknowledgement and follow-up actions
 */
export const getEventRecordQueryControllerGet = (
  eventRecordId: string,
  signal?: AbortSignal,
) => {
  return axiosClient<EventRecordDetailResponseDto>({
    url: `/v1/event-records/${eventRecordId}`,
    method: "GET",
    signal,
  });
};

export const getGetEventRecordQueryControllerGetQueryKey = (
  eventRecordId: string,
) => {
  return [`/v1/event-records/${eventRecordId}`] as const;
};

export const getGetEventRecordQueryControllerGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getEventRecordQueryControllerGet>>,
  TError = void,
>(
  eventRecordId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEventRecordQueryControllerGet>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetEventRecordQueryControllerGetQueryKey(eventRecordId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getEventRecordQueryControllerGet>>
  > = ({ signal }) => getEventRecordQueryControllerGet(eventRecordId, signal);

  return {
    queryKey,
    queryFn,
    enabled: eventRecordId !== null && eventRecordId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getEventRecordQueryControllerGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEventRecordQueryControllerGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEventRecordQueryControllerGet>>
>;
export type GetEventRecordQueryControllerGetQueryError = void;

export function useGetEventRecordQueryControllerGet<
  TData = Awaited<ReturnType<typeof getEventRecordQueryControllerGet>>,
  TError = void,
>(
  eventRecordId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEventRecordQueryControllerGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventRecordQueryControllerGet>>,
          TError,
          Awaited<ReturnType<typeof getEventRecordQueryControllerGet>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetEventRecordQueryControllerGet<
  TData = Awaited<ReturnType<typeof getEventRecordQueryControllerGet>>,
  TError = void,
>(
  eventRecordId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEventRecordQueryControllerGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventRecordQueryControllerGet>>,
          TError,
          Awaited<ReturnType<typeof getEventRecordQueryControllerGet>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetEventRecordQueryControllerGet<
  TData = Awaited<ReturnType<typeof getEventRecordQueryControllerGet>>,
  TError = void,
>(
  eventRecordId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEventRecordQueryControllerGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get an event record with its acknowledgement and follow-up actions
 */

export function useGetEventRecordQueryControllerGet<
  TData = Awaited<ReturnType<typeof getEventRecordQueryControllerGet>>,
  TError = void,
>(
  eventRecordId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEventRecordQueryControllerGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetEventRecordQueryControllerGetQueryOptions(
    eventRecordId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * One-off, idempotent endpoint giving every event record submitted before the Events Hub a status row. Status is derived from whether the record carries an acknowledgement, preserving the original timestamps. Run once immediately after the NAU-341 migration, before exposing the Hub.
 * @summary Backfill event record statuses (platform admin only)
 */
export const backfillEventRecordStatusCommandControllerBackfill = (
  backfillEventRecordStatusDto?: BackfillEventRecordStatusDto,
  signal?: AbortSignal,
) => {
  return axiosClient<BackfillEventRecordStatusResponseDto>({
    url: `/v1/event-records/backfill-status`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: backfillEventRecordStatusDto,
    signal,
  });
};

export const getBackfillEventRecordStatusCommandControllerBackfillMutationOptions =
  <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof backfillEventRecordStatusCommandControllerBackfill>
      >,
      TError,
      { data?: BackfillEventRecordStatusDto },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof backfillEventRecordStatusCommandControllerBackfill>
    >,
    TError,
    { data?: BackfillEventRecordStatusDto },
    TContext
  > => {
    const mutationKey = ["backfillEventRecordStatusCommandControllerBackfill"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof backfillEventRecordStatusCommandControllerBackfill>
      >,
      { data?: BackfillEventRecordStatusDto }
    > = (props) => {
      const { data } = props ?? {};

      return backfillEventRecordStatusCommandControllerBackfill(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type BackfillEventRecordStatusCommandControllerBackfillMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof backfillEventRecordStatusCommandControllerBackfill>
    >
  >;
export type BackfillEventRecordStatusCommandControllerBackfillMutationBody =
  | BackfillEventRecordStatusDto
  | undefined;
export type BackfillEventRecordStatusCommandControllerBackfillMutationError =
  void;

/**
 * @summary Backfill event record statuses (platform admin only)
 */
export const useBackfillEventRecordStatusCommandControllerBackfill = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof backfillEventRecordStatusCommandControllerBackfill>
      >,
      TError,
      { data?: BackfillEventRecordStatusDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof backfillEventRecordStatusCommandControllerBackfill>
  >,
  TError,
  { data?: BackfillEventRecordStatusDto },
  TContext
> => {
  return useMutation(
    getBackfillEventRecordStatusCommandControllerBackfillMutationOptions(
      options,
    ),
    queryClient,
  );
};
/**
 * Adds acknowledgement requests for specific people and puts the record in the Awaiting acknowledgement tab. Their answer is recorded but does NOT close the event or override the configured rule — only the roles in the nursery's acknowledgement rules can do that. Re-asking someone already on the record is a no-op. Permitted to whoever the nursery holds responsible for acknowledging this event type.
 * @summary Ask named individuals to acknowledge an event record
 */
export const requestEventRecordAcknowledgementCommandControllerRequest = (
  eventRecordId: string,
  requestEventRecordAcknowledgementDto: RequestEventRecordAcknowledgementDto,
  signal?: AbortSignal,
) => {
  return axiosClient<RequestEventRecordAcknowledgementResponseDto>({
    url: `/v1/event-records/${eventRecordId}/acknowledgement-requests`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: requestEventRecordAcknowledgementDto,
    signal,
  });
};

export const getRequestEventRecordAcknowledgementCommandControllerRequestMutationOptions =
  <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof requestEventRecordAcknowledgementCommandControllerRequest
        >
      >,
      TError,
      { eventRecordId: string; data: RequestEventRecordAcknowledgementDto },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof requestEventRecordAcknowledgementCommandControllerRequest
      >
    >,
    TError,
    { eventRecordId: string; data: RequestEventRecordAcknowledgementDto },
    TContext
  > => {
    const mutationKey = [
      "requestEventRecordAcknowledgementCommandControllerRequest",
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof requestEventRecordAcknowledgementCommandControllerRequest
        >
      >,
      { eventRecordId: string; data: RequestEventRecordAcknowledgementDto }
    > = (props) => {
      const { eventRecordId, data } = props ?? {};

      return requestEventRecordAcknowledgementCommandControllerRequest(
        eventRecordId,
        data,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RequestEventRecordAcknowledgementCommandControllerRequestMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof requestEventRecordAcknowledgementCommandControllerRequest
      >
    >
  >;
export type RequestEventRecordAcknowledgementCommandControllerRequestMutationBody =
  RequestEventRecordAcknowledgementDto;
export type RequestEventRecordAcknowledgementCommandControllerRequestMutationError =
  void;

/**
 * @summary Ask named individuals to acknowledge an event record
 */
export const useRequestEventRecordAcknowledgementCommandControllerRequest = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof requestEventRecordAcknowledgementCommandControllerRequest
        >
      >,
      TError,
      { eventRecordId: string; data: RequestEventRecordAcknowledgementDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof requestEventRecordAcknowledgementCommandControllerRequest>
  >,
  TError,
  { eventRecordId: string; data: RequestEventRecordAcknowledgementDto },
  TContext
> => {
  return useMutation(
    getRequestEventRecordAcknowledgementCommandControllerRequestMutationOptions(
      options,
    ),
    queryClient,
  );
};
/**
 * Mints a short-lived signed token, calls the pdf-generator-api with the print-ready URL, and returns the signed download URL. Same authorization as the detail endpoint. Returns 503 if the PDF service is unconfigured or unreachable.
 * @summary Generate a PDF of an event record and return a signed download URL
 */
export const getEventRecordPdfQueryControllerGet = (
  eventRecordId: string,
  signal?: AbortSignal,
) => {
  return axiosClient<GetEventRecordPdfResponseDto>({
    url: `/v1/event-records/${eventRecordId}/pdf`,
    method: "GET",
    signal,
  });
};

export const getGetEventRecordPdfQueryControllerGetQueryKey = (
  eventRecordId: string,
) => {
  return [`/v1/event-records/${eventRecordId}/pdf`] as const;
};

export const getGetEventRecordPdfQueryControllerGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getEventRecordPdfQueryControllerGet>>,
  TError = void,
>(
  eventRecordId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEventRecordPdfQueryControllerGet>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetEventRecordPdfQueryControllerGetQueryKey(eventRecordId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getEventRecordPdfQueryControllerGet>>
  > = ({ signal }) =>
    getEventRecordPdfQueryControllerGet(eventRecordId, signal);

  return {
    queryKey,
    queryFn,
    enabled: eventRecordId !== null && eventRecordId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getEventRecordPdfQueryControllerGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEventRecordPdfQueryControllerGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEventRecordPdfQueryControllerGet>>
>;
export type GetEventRecordPdfQueryControllerGetQueryError = void;

export function useGetEventRecordPdfQueryControllerGet<
  TData = Awaited<ReturnType<typeof getEventRecordPdfQueryControllerGet>>,
  TError = void,
>(
  eventRecordId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEventRecordPdfQueryControllerGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventRecordPdfQueryControllerGet>>,
          TError,
          Awaited<ReturnType<typeof getEventRecordPdfQueryControllerGet>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetEventRecordPdfQueryControllerGet<
  TData = Awaited<ReturnType<typeof getEventRecordPdfQueryControllerGet>>,
  TError = void,
>(
  eventRecordId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEventRecordPdfQueryControllerGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventRecordPdfQueryControllerGet>>,
          TError,
          Awaited<ReturnType<typeof getEventRecordPdfQueryControllerGet>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetEventRecordPdfQueryControllerGet<
  TData = Awaited<ReturnType<typeof getEventRecordPdfQueryControllerGet>>,
  TError = void,
>(
  eventRecordId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEventRecordPdfQueryControllerGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Generate a PDF of an event record and return a signed download URL
 */

export function useGetEventRecordPdfQueryControllerGet<
  TData = Awaited<ReturnType<typeof getEventRecordPdfQueryControllerGet>>,
  TError = void,
>(
  eventRecordId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEventRecordPdfQueryControllerGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetEventRecordPdfQueryControllerGetQueryOptions(
    eventRecordId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns the event record detail without a Bearer token. Authorisation is the short-lived signed `token` query parameter issued by `GET /v1/event-records/:id/pdf`.
 * @summary Token-gated event-record read for the print page
 */
export const getEventRecordForPrintQueryControllerGet = (
  eventRecordId: string,
  params: GetEventRecordForPrintQueryControllerGetParams,
  signal?: AbortSignal,
) => {
  return axiosClient<EventRecordDetailResponseDto>({
    url: `/v1/event-records/${eventRecordId}/print`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetEventRecordForPrintQueryControllerGetQueryKey = (
  eventRecordId: string,
  params?: GetEventRecordForPrintQueryControllerGetParams,
) => {
  return [
    `/v1/event-records/${eventRecordId}/print`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetEventRecordForPrintQueryControllerGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getEventRecordForPrintQueryControllerGet>>,
  TError = void,
>(
  eventRecordId: string,
  params: GetEventRecordForPrintQueryControllerGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEventRecordForPrintQueryControllerGet>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetEventRecordForPrintQueryControllerGetQueryKey(eventRecordId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getEventRecordForPrintQueryControllerGet>>
  > = ({ signal }) =>
    getEventRecordForPrintQueryControllerGet(eventRecordId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: eventRecordId !== null && eventRecordId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getEventRecordForPrintQueryControllerGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEventRecordForPrintQueryControllerGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEventRecordForPrintQueryControllerGet>>
>;
export type GetEventRecordForPrintQueryControllerGetQueryError = void;

export function useGetEventRecordForPrintQueryControllerGet<
  TData = Awaited<ReturnType<typeof getEventRecordForPrintQueryControllerGet>>,
  TError = void,
>(
  eventRecordId: string,
  params: GetEventRecordForPrintQueryControllerGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEventRecordForPrintQueryControllerGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventRecordForPrintQueryControllerGet>>,
          TError,
          Awaited<ReturnType<typeof getEventRecordForPrintQueryControllerGet>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetEventRecordForPrintQueryControllerGet<
  TData = Awaited<ReturnType<typeof getEventRecordForPrintQueryControllerGet>>,
  TError = void,
>(
  eventRecordId: string,
  params: GetEventRecordForPrintQueryControllerGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEventRecordForPrintQueryControllerGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventRecordForPrintQueryControllerGet>>,
          TError,
          Awaited<ReturnType<typeof getEventRecordForPrintQueryControllerGet>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetEventRecordForPrintQueryControllerGet<
  TData = Awaited<ReturnType<typeof getEventRecordForPrintQueryControllerGet>>,
  TError = void,
>(
  eventRecordId: string,
  params: GetEventRecordForPrintQueryControllerGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEventRecordForPrintQueryControllerGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Token-gated event-record read for the print page
 */

export function useGetEventRecordForPrintQueryControllerGet<
  TData = Awaited<ReturnType<typeof getEventRecordForPrintQueryControllerGet>>,
  TError = void,
>(
  eventRecordId: string,
  params: GetEventRecordForPrintQueryControllerGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEventRecordForPrintQueryControllerGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetEventRecordForPrintQueryControllerGetQueryOptions(
    eventRecordId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}
